import React, { useState, useEffect, useRef, KeyboardEvent } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Input from '@mui/material/Input';
import { SxProps } from '@mui/system';

const useStyles = makeStyles(
  (theme: Theme) => ({
    wrapper: {},
    wrapperInner: {
      width: '100%',
      display: 'flex',
      flexFlow: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }),
  { name: 'DynamicSearchInput' },
);

interface DynamicSearchInputProps {
  active: boolean;
  // source?: string;
  initialQuery?: string;
  onIconClick?: () => void;
  onClose?: () => void;
  onQueryChange: (val: string) => void;
  sx?: SxProps<Theme>;
}

const DynamicSearchInput: React.FC<DynamicSearchInputProps> = ({
  active,
  onIconClick,
  onQueryChange,
  onClose,
  // source,
  initialQuery = '',
  sx,
}) => {
  const classes = useStyles();
  const [query, setQuery] = useState<string>(initialQuery);
  const ref = useRef<HTMLInputElement>();
  // const history = useHistory();

  useEffect(() => {
    if (active && ref && ref.current) {
      const applyFocus = () => {
        if (ref && ref.current) {
          ref.current.focus();
        }
      };
      const timeout = setTimeout(() => {
        applyFocus();
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [active, ref]);

  // Send the query to the parent...
  useEffect(() => {
    onQueryChange(query);
  }, [onQueryChange, query]);

  // useEffect(() => {
  //   initialQuery ? setQuery(initialQuery) : setQuery('');
  // }, [history.location.pathname, initialQuery]);

  // useEffect(() => {
  //   query ? history.replace({ search: `?query=${query}` }) : history.replace(`${source}`);
  // }, [query, history, source]);

  const handleClear = () => {
    setQuery('');
    // onIconClick && onIconClick(); // triger the close too...
    onClose && onClose();
    // TODO - clear before close logic... - disabled
    // if (query === '') {
    //   // If we are already showing no content, lets toggle the display.
    //   if (onIconClick) onIconClick();
    // } else {
    //   setQuery('');
    //   // Lets maintain focus...
    //   if (ref && ref.current) {
    //     ref.current.focus();
    //   }
    // }
  };

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      ref?.current?.blur();
    }
  };

  return (
    <>
      <Collapse
        classes={{
          wrapper: classes.wrapper,
          wrapperInner: classes.wrapperInner,
        }}
        orientation="horizontal"
        in={active}
        collapsedSize={48}
      >
        <IconButton onClick={onIconClick} id="dedicatedSearch" size="large">
          <SearchIcon />
        </IconButton>
        <Box
          sx={{
            width: '100%',
            ...sx,
          }}
        >
          <Input
            // search input
            inputRef={ref}
            value={query}
            onChange={(ev) => setQuery(ev.target.value)}
            margin="none"
            disableUnderline
            fullWidth
            placeholder="Search for gift cards"
            onKeyDown={onKeyDown}
            endAdornment={
              <IconButton onClick={handleClear} size="large">
                <CloseIcon />
              </IconButton>
            }
          />
        </Box>
      </Collapse>
    </>
  );
};

export default DynamicSearchInput;
